import { GlobalAppState } from '@state/store';

export const getRecentlyViewed = (state: GlobalAppState) => state.recentlyViewed;
